import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CreateUser(
    clientUuid, 
    username,
    password,
    email,
    firstName,
    lastName,        
    role
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/user', {
            method: 'post',
            headers: { 
                'Authorization' : unHashedJwt.data                 
            },
            data: {
                "username": username.trim(),
                "password": password.trim(),
                "email": email.trim(),
                "firstName": firstName.trim(),
                "lastName": lastName.trim(),
                "clientUuid": clientUuid,
                "role": []
            }      
        }).then(res => res)
        .catch(error => error.response.data),
        "Admin"
        );
}